import ReactDOM from 'react-dom'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import App from './App'
import store from './Store'
import { Provider } from 'react-redux'
import { ErrorBoundary } from 'react-error-boundary'
// import UnexpectedErrorPage from './Layouts/Errors/UnexpectedErrorPage';
import EmptyLayout from './Layouts/empty'
import SignInCallbackPage from './Oidc/SignInCallbackPage'
import SignOutCallbackPage from './Oidc/SignOutCallbackPage'
import CantLogin from './Oidc/CantLogin'
import SignOut from 'Oidc/SignOut'
import './index.css'
import InitialTranslation from 'Hooks/Translation/InitialTranslation'
import CommonApiPaths from 'Application/Common/Constants/CommonApiPaths'
import Const from 'Utils/Consts'
import { SettingsProvider } from 'Contexts/SettingsContext'
import { NetStatusProvider } from 'Contexts/NetStatusContext'

ReactDOM.render(
  // <React.StrictMode>
  <Provider store={store}>
    {/* <ErrorBoundary FallbackComponent={UnexpectedErrorPage}> */}
    <NetStatusProvider>
      <SettingsProvider>
        <EmptyLayout>
          <InitialTranslation
            resourcePath={
              Const.env.REACT_APP_API_GATEWAY_URL + CommonApiPaths.Translation.GetAllJson
            }
          >
            <Router>
              <Routes>
                <Route path="/SignInCallBack" element={<SignInCallbackPage />} />
                <Route path="/SignOutCallBack" element={<SignOutCallbackPage />} />
                <Route path="/SignOut" element={<SignOut />} />
                <Route path="/CantLogin" element={<CantLogin />} />
                <Route path="*" element={<App />} />
              </Routes>
            </Router>
          </InitialTranslation>
        </EmptyLayout>
      </SettingsProvider>
    </NetStatusProvider>
    {/* </ErrorBoundary> */}
  </Provider>,
  // </React.StrictMode>
  document.getElementById('root'),
)
